import React from "react"; 

// core components
import GridItem from "../../views/Grid/GridItem.js";
import GridContainer from "../../views/Grid/GridContainer.js";
import Table from "../../views/Table/Table.js";
import Card from "../../views/Card/Card.js";
import CardHeader from "../../views/Card/CardHeader.js";
import CardBody from "../../views/Card/CardBody.js";

import axios from 'axios'
import style from './styles.module.css'
import Button from '@material-ui/core/Button'
import ConfProduct from './confProduct/ConfProduct'
import IconButton from '@material-ui/core/IconButton'
import EditRoundedIcon from '@material-ui/icons/EditRounded';
import DeleteRoundedIcon from '@material-ui/icons/DeleteRounded';
import InputRoundedIcon from '@material-ui/icons/InputRounded';
import Snackbar from '../utils/snackbar/Snackbar'
import {withRouter} from 'react-router-dom'
import ProductDetail from "./productDetail/ProductDetail";
import CircularProgress from '@material-ui/core/CircularProgress'
import TopBar from "../utils/Topbar/TopBar.js";
import SplitButton from "../utils/SplitButton/SplitButton.js";
import PrintRoundedIcon from '@material-ui/icons/PrintRounded';
import Tooltip from '@material-ui/core/Tooltip';
import BarCode from './barcodePrint/BarCode'
import {connect} from 'react-redux'
import DownloadBarcode from "./barcodePdf/DownloadBarCode.js";
import ConfirmAlert from "../utils/ConfirmAlert/ConfirmAlert";

const Product = (props) => { 
  const [data,setData] = React.useState(false)
  const [filteredData,setFilteredData] = React.useState(false)
  const [searchValue,setSearchValue] = React.useState("")
  const [selectValue,setSelectValue] = React.useState("ALL")
  const [alert,setAlert] = React.useState(false);
  const [addModal,setAddModal] = React.useState(false);
  const [editModal,setEditModal] = React.useState(false);
  const [activeProduct,setActiveProduct] = React.useState(false)
  const [detailModal,setDetailModal] = React.useState(false);
  const [barcode,setBarCode] = React.useState(false);
  const [activeWareHouse,setActiveWarehouse] = React.useState(false)

  React.useEffect(() => {
    const query = new URLSearchParams(props.location.search);
    if(query.get("warehouseId")) {
      setActiveWarehouse(query.get("warehouseId"))
    } else {
      setActiveWarehouse(false)
    } 
  },[props.location.search]);


  React.useEffect(() => {
    fetchOrder()
  },[]);


  React.useEffect(() => {
    if(data) {
      let arr = [];
      arr = data.filter(val => {
        if((val.productName && val.productName.toLowerCase().includes(searchValue.toLowerCase())) || 
            (val.description && val.description.toLowerCase().includes(searchValue.toLowerCase())) || 
            (val.productCode && val.productCode.toLowerCase().includes(searchValue.toLowerCase()))
          ) {
          return val;
        }
      })
      arr = arr.filter(val => {
        if(val.status == selectValue || selectValue == "ALL") {
          return val;
        }
      })
      setFilteredData(arr);
    }
  },[searchValue,selectValue])

  const fetchOrder = () => {
    setData(false);
    axios({
      method: "post",
      url: "/getAllProductsApi", 
      data: {
        userId: props.user._id
      }
    }).then(res => {
      setData(res.data.data)  
      setFilteredData(res.data.data)
    }).catch(err => {
      console.log(err)
    });
  }


  const handleDelete = (value) => {
    axios({
      method: "post",
      url: "/deleteProductApi",
      data: {
        productId: value._id,
      }
    }).then(res => {
      setAlert("Deleted Successfully")
      fetchOrder();
    }).catch(err => {
      setAlert("Something went wrong");
    })
  }

  const isLoading = !filteredData;
  const showData = !isLoading;
  const details = [];
 
  let productStatus = ["ALL"]
  data && data.forEach(val => { 
    productStatus.push(val.status);
  }); 
  productStatus = [...new Set(productStatus)]
 
  !isLoading && filteredData.forEach((val, index) => {
    let totalCbm = 0;
    
     val.productParts.forEach(part => part.partId ? totalCbm += parseInt(part.partId.height) * parseInt(part.partId.length) * parseInt(part.partId.width) : "") 
    
    if(!activeWareHouse || val.warehouseId._id == activeWareHouse) {
      details.push(
        [
          index + 1,
          val.productName,
          val.product_barcode,
          val.productCost,
          totalCbm,  
          val.CnF,
          val.status,
          val.weight,
          <React.Fragment> 

            <Tooltip title="View Details">
              <IconButton onClick={() => {
                setDetailModal(true)
                setActiveProduct(val)
              }}>
                <InputRoundedIcon />
              </IconButton>
            </Tooltip>

            <Tooltip title="Edit Product">
              <IconButton onClick={() => {
                setActiveProduct(val)
                setEditModal(true)
              }}>
                <EditRoundedIcon />
              </IconButton>
            </Tooltip>
            
            <ConfirmAlert msg={`Are you sure you want delete ?`} onClickEvent={() => handleDelete(val)}>
              <Tooltip title="Delete Product">
                <IconButton>
                  <DeleteRoundedIcon />
                </IconButton>
              </Tooltip>
            </ConfirmAlert>

          </React.Fragment>
        ]
      )
    }
  })



  return (
    <GridContainer>
      
      {addModal && <ConfProduct
        type="ADD" 
        open={addModal} 
        onClose={() => setAddModal(false)} 
        onDone={() => {
          setAddModal(false)
          fetchOrder()
        }}
        setAlert={(msg) => setAlert(msg)}
      />}
      {editModal && <ConfProduct 
        type="EDIT"
        product={activeProduct} 
        open={editModal} 
        onClose={() => setEditModal(false)} 
        onDone={() => {
          setEditModal(false)
          setActiveProduct(false)
          fetchOrder()
        }} 
        setAlert={(msg) => setAlert(msg)}
      />} 

      {detailModal && 
        <ProductDetail 
          open={detailModal}
          onClose={() => setDetailModal(false)}
          product={activeProduct}
        />
      } 

      {barcode &&
        <BarCode product={activeProduct} open={barcode} onClose={() => setBarCode(false)}/>
      }
      <Snackbar open={alert} handleClose={() => setAlert(false)}/>


      <TopBar 
        searchValue={searchValue} 
        onSearchChange={(value) => setSearchValue(value)} 

        select={true}
        selectValue={selectValue}
        handleSelectChange={(value) => setSelectValue(value)}
        lable="Status"
        options={productStatus}
        values={productStatus}
      />

      <GridItem xs={12} sm={12} md={12}>
        <Card>
          <CardHeader color="primary">
            <div className={style.cardHeader}>
              <h4>All Products</h4> 

              <div className={style.headerButtons}>
                <Button color="secondary" variant="contained" onClick={() => setAddModal(true)}>Add Product</Button> 
              </div>
            </div>
          </CardHeader>
          <CardBody>
            {isLoading &&
              <div className={style.loader}>
                <CircularProgress />
              </div>
            }
            
            {showData && 
              <Table
                tableHeaderColor="primary"
                tableHead={[ "Sl No","Name", "Product Code", "MRP", "CBM", "Cnf", "Status", "Weight",  "Action"]}
                tableData={details}
              />}
          </CardBody>
        </Card>
      </GridItem> 
    </GridContainer>
  );
}

const mapStateToProps = state =>({
  user: state.appReducer.user
});
export default withRouter(connect(mapStateToProps )(Product));